import { render, staticRenderFns } from "./QuadratureReport.vue?vue&type=template&id=ffd2e5c8&"
import script from "./QuadratureReport.vue?vue&type=script&lang=js&"
export * from "./QuadratureReport.vue?vue&type=script&lang=js&"
import style0 from "./QuadratureReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports